module.exports = __webpack_public_path__ + "assets/img/Group2100.717e0ff7.png";